import LoginModel, { LoggedUserInformation } from './loginModel';
import * as axios from 'axios';

const url = `${process.env.VUE_APP_API_URL}/account/login`;

export default function login(model: LoginModel) {
    return axios.default.post<LoggedUserInformation>(url, model);
}
